import { Component, EventEmitter, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { OrganisationService } from 'src/app/services/organisation/organisation.service';
import { AddEditDepartmentComponent } from '../add-edit-department/add-edit-department.component';
import { DepartmentHelpModalComponent } from '../department-help-modal/department-help-modal.component';
import { AlertBannerService, AlertType } from 'src/app/lib/alert-banner';

import * as _ from 'lodash';
import {ConstantsService} from "../../services/constants/constants.service";

@Component({
  selector: 'app-org-departments-modal',
  templateUrl: './org-departments-modal.component.pug',
  styleUrls: ['./org-departments-modal.component.scss'],
  standalone: false
})
export class OrgDepartmentsModalComponent implements OnInit, OnDestroy {

  @Input() departmentList: any = [];
  @Input() deletedDepartmentsList: any = [];
  @Input() totalDepartments: any;
  @Input() enabledDepartments: any;
  @Input() deleteHandler: ((department: any) => void) | null = null;
  filteredList: any = [];
  org_loaded: any = true
  showValidationError = false;
  searchOptions = [{ label: $localize`Department`, value: 'department' }, { label: $localize`Category`, value: "category_name" }];
  searchOptionsCore = [{ label: $localize`Department`, value: 'department', hint:$localize`Department name` }, { label: $localize`Category`, value: "category_name", hint:$localize`Department category` }];
  searchLabels = this.searchOptions.map(each => each.label)
  searchTags: any = [];
  bsModalRef!: BsModalRef;
  addModal: BsModalRef = new BsModalRef();
  editModal: BsModalRef = new BsModalRef();
  helpModal: BsModalRef = new BsModalRef();
  allDetailedDepartments: any = [];
  private deleteClickSubscription: Subscription | null = null;
  otherDepartmentTooltip = $localize`This department exists by default. It cannot be edited, deleted or disabled.`
  unspecifiedDepartmentTooltip = $localize`This department exists by default. It cannot be edited, deleted or disabled.`

  searchTitle = ConstantsService.searchTitle;
  searchDescription = ConstantsService.searchDescription;
  searchImg = ConstantsService.searchImg;

  deleteClick: EventEmitter<any> = new EventEmitter<any>();
  closeModalEvent: EventEmitter<any> = new EventEmitter<any>();

  sortCriteria = {
    sortOptions: [
      {
        'label': $localize`Department`,
        'type': "word",
        'value': "department"
      },
      {
        'label': $localize`Department category`,
        'type': "word",
        'value': "category_name"
      },
    ],
    sortString: 'department',
    sortOrder: 'asc'
  }
  @Input() paginationCriteria = {
    total: 0,
    rowsPerView: 20,
    currentPage: 1,
  }
  @Input() paginationCheck = true
  constructor(
    public _bsModalRef: BsModalRef,
    public modal: WarningModalService,
    public modalService: BsModalService,
    public permissions: PermissionsService,
    public organisationService: OrganisationService,
    private alertList: AlertBannerService,
  ) { }

  ngOnInit(): void {
    this.setFilteredList(this.departmentList, 0)
    this.getAllDepartments()
    // Subscribe to deleteClick if handler is provided (for recreated modal instances)
    // Only subscribe if not already subscribed to prevent duplicate subscriptions
    if (this.deleteHandler && !this.deleteClickSubscription) {
      const handler = this.deleteHandler;
      this.deleteClickSubscription = this.deleteClick.subscribe(department => {
        handler(department);
      });
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe from deleteClick subscription to prevent memory leaks
    if (this.deleteClickSubscription) {
      this.deleteClickSubscription.unsubscribe();
      this.deleteClickSubscription = null;
    }
  }

  closeModal() {
    this.closeModalEvent.emit();
    this._bsModalRef.hide();
  }
  processCreates() {
    let addList = this.departmentList.filter(each => each.newData == true);
    if (addList.length > 0) {
      this.organisationService.addDepartments(addList).subscribe(data => {
        if (data.data['saved']) {

          let newDepartments = data.data["new_departments"];
          let newDepartmentMap: Map<string, any> = new Map(newDepartments.map(item => [item.department, item]));

          this.departmentList = this.departmentList.map((value, index) => {
            if (value.id === undefined && newDepartmentMap.has(value.department)) {
              return newDepartmentMap.get(value.department);
            }
            return value;
          })

          this.organisationService.setNewDepartments({
            "departments": this.paginationCriteria.currentPage === 1 ? this.departmentList : null,
            "total_departments": this.totalDepartments + addList.length
          }
          );

          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! Changes have been saved.`,
            keepOnRouteChange: true
          }]);

          addList.forEach(data => data.newData = false)
          this._bsModalRef.hide();

        }
      },
        error => {
          console.log(error);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        })
    }

  }
  processEdits() {
    if (this.searchTags && this.searchTags.length) {
      let editList = this.filteredList.filter(each => each.modified == true && each.id);
      if (editList.length > 0) {
        this.organisationService.updateDepartments(editList).subscribe(data => {
          if (data.data['saved']) {
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! Changes have been saved.`,
              keepOnRouteChange: true
            }]);

            this.organisationService.setNewDepartments({
              "departments": this.paginationCriteria.currentPage === 1 ? this.departmentList : null,
              "total_departments": this.totalDepartments
            }
            );

            editList.forEach(element => {
              element.modified = false;
            });
            this._bsModalRef.hide()
          }
        },
          error => {
            console.log(error);
            if (error.error.data.survey_data) {
              this.alertList.append([{
                type: AlertType.DANGER,
                message: $localize`This department has been used and can no longer be edited.`,
                keepOnRouteChange: true
              }]);
            }
            else {
              this.alertList.append([{
                type: AlertType.DANGER,
                message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                keepOnRouteChange: true
              }]);
            }
          })
      }
      else {
        this._bsModalRef.hide();
      }
    }
    else {
      let editList = this.departmentList.filter(each => each.modified == true && each.id);
      if (editList.length > 0) {
        this.organisationService.updateDepartments(editList).subscribe(data => {
          if (data.data['saved']) {
            this.alertList.append([{
              type: AlertType.SUCCESS,
              message: $localize`Success! Changes have been saved.`,
              keepOnRouteChange: true
            }]);

            this.organisationService.setNewDepartments({
              "departments": this.paginationCriteria.currentPage === 1 ? this.departmentList : null,
              "total_departments": this.totalDepartments
            }
            );

            editList.forEach(element => {
              element.modified = false;
            });
            this._bsModalRef.hide()
          }
        },
          error => {
            console.log(error);
            if (error.error.data.survey_data) {
              this.alertList.append([{
                type: AlertType.DANGER,
                message: $localize`This department has been used and can no longer be edited.`,
                keepOnRouteChange: true
              }]);
            }
            else {
              this.alertList.append([{
                type: AlertType.DANGER,
                message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                keepOnRouteChange: true
              }]);
            }
          })
      }
      else {
        this._bsModalRef.hide();
      }
    }
  }

  processDeletes() {
    if (this.deletedDepartmentsList.length) {
      const newTotalDepartments = this.totalDepartments - this.deletedDepartmentsList.length
      this.organisationService.setNewDepartments({ "total_departments": newTotalDepartments })
      this.organisationService.deleteDepartments(this.deletedDepartmentsList).subscribe(response => {
        if (response.data['deleted']) {
          this.deletedDepartmentsList = [];
          this.alertList.append([{
            type: AlertType.SUCCESS,
            message: $localize`Success! Changes have been saved.`,
            keepOnRouteChange: true
          }]);
        }
        this._bsModalRef.hide();
      },
      (error)=>{
        console.log(error);
          if (error.error.data.survey_data) {
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`This department has been used and can no longer be deleted.`,
              keepOnRouteChange: true
            }]);
          }
          else {
            this.alertList.append([{
              type: AlertType.DANGER,
              message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
              keepOnRouteChange: true
            }]);
          }
      });
    }
  }

  save() {
    this.processEdits();
    this.processCreates();
    this.processDeletes();
    this.organisationService.getAllDepartments(true);
  }

  onSearchEvent(event) {
    this.searchTags = [];
    if (event.type === 'all') {
      this.createTag(event.type, event.search);
    } else {
      const searchType = this.searchOptions.filter(each => each.label === event.type)[0]
      this.createTag(searchType.label, event.search);
    }

    this.filterDepartmentList();
  }

  createTag(label, value) {
    this.searchTags.push({ label, value });
  }

  closeTag(tagIndex) {
    this.searchTags.splice(tagIndex, 1);
    this.filterDepartmentList();
  }

  filterDepartmentList() {
    let tempList;
    tempList = _.cloneDeep(this.allDetailedDepartments)
    this.searchTags.forEach(tag => {
      if (tag.label === 'all') {
        tempList = tempList.filter(each => each.department.toLocaleLowerCase().includes(tag.value.toLocaleLowerCase()) || each.category_name.toLocaleLowerCase().includes(tag.value.toLocaleLowerCase()));
      } else {
        const searchType = this.searchOptions.filter(each => each.label === tag.label)[0]
        tempList = tempList.filter(each => each[searchType.value].toLocaleLowerCase().includes(tag.value.toLocaleLowerCase()));
      }
    })

    this.filteredList = tempList;
    this.filteredList.forEach(each => each.editable = !each.survey_data_collected);
  }

  clearTags() {
    this.searchTags = [];
    this.filteredList = this.departmentList;
  }

  onSortChange(sortString: string): void {
    this.sortCriteria.sortString = sortString;
    this.paginateData(this.paginationCriteria.currentPage)
  }


  onPageChange(pageNumber) {
    this.searchTags = [];
    this.paginationCriteria = { ...this.paginationCriteria, currentPage: pageNumber }
    if (this.paginationCheck) this.paginateData(pageNumber);
    else {
      this.sortDepartmentLocally(this.filteredList)
      this.paginationCheck = !this.paginationCheck;
    }
  }

  paginateData(pageNumber: number) {
    const rowsPerView: number = this.paginationCriteria.rowsPerView;
    let offset: number = (pageNumber - 1) * rowsPerView
    let limit: number = this.paginationCriteria.rowsPerView
    this.org_loaded = false;

    if (offset > 0) offset--;
    if (offset === 0) limit--;

    let sort = this.sortCriteria.sortString
    if (sort == "category_name") sort = "category__name"
    else if (sort == "-category_name") sort = "-category__name"

    this.organisationService
      .getPaginatedDepartments(offset, limit, sort)
      .subscribe(
        (data: any) => {
          this.departmentList = data.data.departments
          this.setFilteredList(this.departmentList, offset)
          this.org_loaded = true;
        },
        (error: any) => {
          this.setFilteredList([], offset);
          this.org_loaded = true
        }
      );
  }

  setFilteredList(data: any, offset: any): void {
    this.filteredList = data
    this.filteredList.forEach(each => each.editable = !each.survey_data_collected);
    this.paginationCriteria = { ...this.paginationCriteria, total: this.totalDepartments };
    if (offset === 0) this.moveUnspecifiedDepartment();
    }

  sortDepartmentLocally(data) {
    let sortString = this.sortCriteria.sortString;
    if (sortString.includes('-')) {
      sortString = sortString.substring(1);
      this.filteredList = data.sort((a, b) =>
        a[sortString].toLowerCase() < b[sortString].toLowerCase()
          ? 1
          : b[sortString].toLowerCase() < a[sortString].toLowerCase()
            ? -1
            : 0
      );
    } else {
      this.filteredList = data.sort((a, b) =>
        a[sortString].toLowerCase() > b[sortString].toLowerCase()
          ? 1
          : b[sortString].toLowerCase() > a[sortString].toLowerCase()
            ? -1
            : 0
      );
    }

  }

  moveOtherDepartment() {
    const foundIndex = this.filteredList.findIndex(each => each.department === 'Other' && each.category_name === 'Other' && each.is_default === true)

    if (foundIndex >= 0) {
      this.filteredList[foundIndex].read_only = true;
      this.filteredList[foundIndex].editable = false;
    }

    this.filteredList.unshift(this.filteredList.splice(foundIndex, 1)[0])
  }

  moveUnspecifiedDepartment() {
    const foundIndex = this.filteredList.findIndex(each => each.department === 'Unspecified' && each.category_name === 'Unspecified' && each.is_default === true)

    if (foundIndex >= 0) {
      this.filteredList[foundIndex].read_only = true;
      this.filteredList[foundIndex].editable = false;
    }

    this.filteredList.unshift(this.filteredList.splice(foundIndex, 1)[0]);
  }

  onPageSizeChange(rowsPerView) {
    this.searchTags = [];
    this.paginationCriteria = { ...this.paginationCriteria, rowsPerView: rowsPerView, currentPage: 1 }
    this.paginateData(1);
  }

  departmentToggle(department) {
    this.departmentToggleWithFF(department);
  }

  departmentToggleWithFF(department) {
    if (this.filteredList.length > 0) {
      const foundIndex = this.filteredList.findIndex(each => each.id == department.id)
      if (foundIndex >= 0) {
        this.filteredList[foundIndex].disabled = !this.filteredList[foundIndex].disabled
        this.filteredList[foundIndex].modified = true
        this.filteredList[foundIndex].toggle = true
      }
    } else {
      const foundIndex = this.departmentList.findIndex(each => each.id == department.id)
      if (foundIndex >= 0) {
        this.departmentList[foundIndex].disabled = !this.departmentList[foundIndex].disabled
        this.departmentList[foundIndex].modified = true
        this.departmentList[foundIndex].toggle = true
      }
    }
  }

  addDepartmentModal() {
    let department = {}
    let initialState = {
      'model': 'add',
      'dept_data': department,
      'dept_list': this.departmentList
    }
    this.addModal = this.modalService.show(AddEditDepartmentComponent, {
      class: 'modal-dialog-centered max-width-552 max-height-341', initialState
    });
    this._bsModalRef.hide()
    this.addModal.onHide?.subscribe(() => {
      let initialState = {
        'departmentList': this._bsModalRef.content.departmentList,
        'totalDepartments': this.totalDepartments,
        'enabledDepartments': this.enabledDepartments,
        'paginationCriteria': this.paginationCriteria,
        'paginationCheck': false,
        'deleteHandler': this.deleteHandler,
      };
      this._bsModalRef = this.modalService.show(OrgDepartmentsModalComponent, {
        class: 'modal-dialog-centered modal-lg', initialState
      });
    })
    this.addModal.content.event.subscribe(updates => {
      this.departmentList.splice(0, 0, {
        "department": updates.department,
        "category_name": updates.category_name,
        "disabled": false,
        "newData": true,
        "category_id": updates.id
      });
    });
  }

  editDepartmentModal(department) {
    if (!department.read_only && department.editable) {
      if (this.searchTags && this.searchTags.length){
        let initialState = {
          'model': 'edit',
          'dept_data': department,
          'dept_list': this.filteredList
        }
        this.editModal = this.modalService.show(AddEditDepartmentComponent, {
          class: 'modal-dialog-centered max-width-552 max-height-341', initialState
        });
        this._bsModalRef.hide()
        this.editModal.onHide?.subscribe(() => {
          let initialState = {
            "departmentList": this._bsModalRef.content.filteredList,
            "filteredList": this._bsModalRef.content.filteredList,
            'totalDepartments': this.totalDepartments,
            'enabledDepartments': this.enabledDepartments,
            'paginationCriteria': this.paginationCriteria,
            'paginationCheck': false,
            'searchTags': this.searchTags,
            'deleteHandler': this.deleteHandler,
          }
          this._bsModalRef = this.modalService.show(OrgDepartmentsModalComponent, {
            class: 'modal-dialog-centered modal-lg', initialState
          });
        })
        this.editModal.content.event.subscribe(updates => {
          this.filteredList.forEach(each => {
            if (each.id == updates.id) {
              each.department = updates.department;
              each.category_name = updates.category_name;
              each.category_id = updates.category_id
              each.modified = true;
              each.toggle = false;
              if (updates.category_name === 'Unspecified') each.read_only = true;
            }
          });
        });
      }
      else {
        let initialState = {
          'model': 'edit',
          'dept_data': department,
          'dept_list': this.departmentList
        }
        this.editModal = this.modalService.show(AddEditDepartmentComponent, {
          class: 'modal-dialog-centered max-width-552 max-height-341', initialState
        });
        this._bsModalRef.hide()
        this.editModal.onHide?.subscribe(() => {
          let initialState = {
            "departmentList": this._bsModalRef.content.departmentList,
            'totalDepartments': this.totalDepartments,
            'enabledDepartments': this.enabledDepartments,
            'paginationCriteria': this.paginationCriteria,
            'paginationCheck': false,
            'deleteHandler': this.deleteHandler,
          }
          this._bsModalRef = this.modalService.show(OrgDepartmentsModalComponent, {
            class: 'modal-dialog-centered modal-lg', initialState
          });
        })
        this.editModal.content.event.subscribe(updates => {
          this.departmentList.forEach(each => {
            if (each.id == updates.id) {
              each.department = updates.department;
              each.category_name = updates.category_name;
              each.category_id = updates.category_id
              each.modified = true;
              each.toggle = false;
              if (updates.category_name === 'Unspecified') each.read_only = true;
            }
          });
        });
      }
    }
  }

  openHelpModal() {

    this.helpModal = this.modalService.show(DepartmentHelpModalComponent, {
      class: 'modal-dialog-centered max-width-552 max-height-411'
    });
    this._bsModalRef.hide();
    this.helpModal.onHide?.subscribe(() => {
      let initialState = {
        'departmentList': this._bsModalRef.content.departmentList,
        'totalDepartments': this.totalDepartments,
        'enabledDepartments': this.enabledDepartments,
        'paginationCriteria': this.paginationCriteria,
        'paginationCheck': false,
        'deleteHandler': this.deleteHandler,
      };
      this._bsModalRef = this.modalService.show(OrgDepartmentsModalComponent, {
        class: 'modal-dialog-centered modal-lg', initialState
      });
    })
  }

  showDeleteDepartmentModal(department) {
    if (department.editable && department.id) {
      this._bsModalRef.hide();
      this.deleteClick.emit(department);

    }
    else if (!department?.id) {
      this.departmentList = this.departmentList.filter(each => each.department !== department.department);
      this.filterDepartmentList();
    }
  }
  getAllDepartments(){
    this.organisationService.getAllDetailedDepartments(true).subscribe((res)=>{
      this.allDetailedDepartments = res.departments
    },
    (error)=>{
      console.log(error);
    })
  }
}
